import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';

export type RestoreConfirmModalProps =
  | {
      open: boolean;
      variant: 'bulkRecords';
      selectedCount: number;
      operationCount: number;
      onConfirm: () => void;
      onClose: () => void;
      isProcessing?: boolean;
    }
  | {
      open: boolean;
      variant: 'bulkFolders';
      selectedCount: number;
      onConfirm: () => void;
      onClose: () => void;
      isProcessing?: boolean;
    };

export default function RestoreConfirmModal(props: RestoreConfirmModalProps) {
  const isProcessing = props.isProcessing ?? false;

  const title =
    props.variant === 'bulkFolders' ? 'Restore selected folders' : 'Restore selected records';

  const body =
    props.variant === 'bulkFolders'
      ? props.selectedCount === 1
        ? `Restore this folder and its deleted contents from the database? Cloud files removed during delete may still be missing.`
        : `Restore ${props.selectedCount} selected folders and their deleted contents from the database? Cloud files removed during delete may still be missing.`
      : props.selectedCount === 1
        ? `Restore this row? This runs ${props.operationCount} restore operation (bundled items may share one restore). The item will reappear in its source page.`
        : `Restore ${props.selectedCount} selected rows? This runs ${props.operationCount} restore operation(s)—rows that belong to the same bundle share one restore. Items will reappear in their source pages.`;

  return (
    <Dialog open={props.open} onClose={() => !isProcessing && props.onClose()} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{body}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} disabled={isProcessing}>
          Cancel
        </Button>
        <Button
          onClick={props.onConfirm}
          variant="contained"
          disabled={isProcessing}
          startIcon={isProcessing ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          {isProcessing ? 'Restoring…' : 'Restore'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
